import { thunk } from 'redux-thunk';
import { composeWithDevTools } from '@redux-devtools/extension';
import { applyMiddleware, compose, createStore, combineReducers } from 'redux';
import { StateShape, reducers } from './reducers';

export default async function configureStore(initialState?: Partial<StateShape>) {
    const middleware = [thunk];
    let enhance;

    if (process.env.NODE_ENV === 'development') {
        const { logger } = await import('redux-logger');
        middleware.push(logger);
        enhance = composeWithDevTools(applyMiddleware(...middleware));
    } else {
        enhance = compose(applyMiddleware(...middleware));
    }

    const rootReducer = combineReducers({
        ...reducers
    });

    return createStore(rootReducer, initialState as any, enhance);
}
